import CRUD from './crud';

const superiorJudges = new CRUD('superior-judges', 'superior-judge', 'superiorJudges');

export default Object.assign(superiorJudges, {
    reducers: {
        ...superiorJudges.reducers,
    },
});
